import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
import withStateReinit from 'hocs/WithStateReinit';
// Core components
import Card from 'components/core/Card';
import TextField from 'components/core/TextField';
import Typography from 'components/core/Typography';
// Models
import mPlanning from 'models/cpm/planning';
// Custom
import { cpmPlanningDataShape, errorShape } from 'constants/PropTypesShapes';
import { buildFormErrors, cpmPlanningConstraints } from 'utils/Forms';
import FormDialogTemplate from 'components/templates/FormDialogTemplate';
import FormHelper from 'components/misc/FormHelper';
import PlanningWeekEdit from 'components/plannings/PlanningWeekEdit';

class PlanningAddEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: {
        name, events, enabled,
      },
      planning, onErrorsChange, onValidate,
    } = this.props;

    const errors = buildFormErrors({ name }, cpmPlanningConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate(mPlanning.serialize({
        name,
        slots: mPlanning.eventsToSlots(events),
        enabled,
      }), planning);
      return true;
    }
    return false;
  }

  render() {
    const {
      fields: {
        name, events,
      }, errors,
      onFieldsChange,
    } = this.props;

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <div className="d-flex">
              <FormHelper elements={[]} />
              <div style={{ flex: 1 }}>
                <Card>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                      <TextField
                        required
                        label={<LocalizedMessage id="field.name" />}
                        errorText={_get(errors, 'name')}
                        value={name}
                        onChange={(value) => onFieldsChange({ name: value })}
                      />
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
          <div className="col-12 pt-3">
            <div className="d-flex">
              <FormHelper
                elements={[
                  {
                    content: <LocalizedMessage id="help.plannings.formWeek1" />,
                  },
                  {
                    content: <LocalizedMessage id="help.plannings.formWeek2" />,
                  },
                  {
                    content: <LocalizedMessage id="help.plannings.formWeek3" />,
                  },
                ]}
              />
              <div style={{ flex: 1 }}>
                <Card
                  title={(
                    <Typography type="subtitle2">
                      <LocalizedMessage id="field.planningTimeSlots" />
                    </Typography>
                  )}
                >
                  <div className="row">
                    <div className="col-12">
                      <PlanningWeekEdit
                        events={events}
                        completeMode
                        onChange={(value) => onFieldsChange({ events: value })}
                      />
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </FormDialogTemplate>
    );
  }
}

PlanningAddEditForm.propTypes = {
  operation: PropTypes.oneOf(['add', 'update']).isRequired, // eslint-disable-line react/no-unused-prop-types
  planning: cpmPlanningDataShape,
  operationError: errorShape, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

PlanningAddEditForm.defaultProps = {
  planning: null,
  operationError: null,
  errors: null,
};

const mapFieldsToProps = {
  name: {
    resourceKey: 'name',
    defaultValue: '',
  },
  enabled: {
    resourceKey: 'enabled',
    defaultValue: true,
  },
  events: {
    resourceKey: 'slots',
    defaultValue: [],
    setTransform: (slots) => (mPlanning.slotsToEvents(slots)),
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.planning,
  operationError: ownProps.operationError,
});

const mapStateToProps = (state, ownProps) => ({
  operationError: _get(state.cpmCarparkPlanning, [ownProps.operation, 'error']),
});

module.exports = compose(
  connect(
    mapStateToProps,
  ),
  withFormManagement(
    mapFieldsToProps,
    mapOwnPropsToResources,
    false,
  ),
  withStateReinit(['addCarparkPlanning', 'updateCarparkPlanning']),
)(PlanningAddEditForm);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/plannings/PlanningAddEditForm.js